import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';
import 'src/App.css';
import { StoreProvider } from 'src/context/StoreContext';
import { NotifyProvider } from 'src/context/ContextNotify';
import { DataSmallProvider } from 'src/context/ContextDataSmall';
import DefaultLayout from 'src/components/template/DefaultLayout';
import ProtectedRoutes from './ProtectedRoutes';
import Reception from 'src/pages/Reception';
import Login from 'src/pages/Login';
import Calendar from 'src/pages/Calendar';
import MedicalSchema from 'src/pages/MedicalSchema';
import ReservationList from 'src/pages/ReservationList';
import Quotations from 'src/pages/Quotations';
import QuotationDetail from 'src/pages/QuotationDetail';
import Patients from 'src/pages/patients/Patients';
import PatientDetail from 'src/pages/patients/PatientDetail';
import PatientView from 'src/pages/patients/PatientView';
import PatientHistory from 'src/pages/patients/PatientHistory';
import Tasks from 'src/pages/task/Tasks';
import SurgeryCalendar from 'src/pages/task/SurgeryCalendar';
import TaskCreate from 'src/pages/task/TaskCreate';
import PatientIntegration from 'src/pages/patients/PatientIntegration';
import NotFound from 'src/pages/NotFound';
// import Socket from 'src/components/socket/Socket';
import InventoryManagement from 'src/pages/InventoryManagement';
import SurgicalInventoryMangement from 'src/pages/SurgicalInventoryManagement';
import MasterTreatment from 'src/pages/master/Treatment';
import MasterMerchandise from 'src/pages/master/Merchandise';
import MasterSurgicalMaterials from 'src/pages/master/SurgicalMaterials';
import MasterDesiredTreatment from 'src/pages/master/DesiredTreatment';
import MasterDoctorFee from 'src/pages/master/DoctorFee';
import SettingUsers from 'src/pages/settings/Users';
import SettingUserView from 'src/pages/settings/UserView';
import SettingUserEdit from 'src/pages/settings/UserEdit';
import SettingUserChangePassword from 'src/pages/settings/UserChangePassword';
import SettingCalendarColor from 'src/pages/settings/CalendarColor';
import SettingPatientIcon from 'src/pages/settings/PatientIcon';
import SettingTime from 'src/pages/settings/Time';
import SettingTimeEdit from 'src/pages/settings/TimeEdit';
import SettingSite from 'src/pages/settings/Site';
import TemplateMail from 'src/pages/templates/Mail';
import TemplateMailLog from 'src/pages/templates/MailLog';
import TemplateQuotation from 'src/pages/templates/Quotation';
import TemplateMailView from 'src/pages/templates/MailView';
import TemplateMailEdit from 'src/pages/templates/MailEdit';
import Payments from 'src/pages/Payments';
import ReportDownload from 'src/pages/report/Download';
import ReportPayment from 'src/pages/report/Payment';
import ReportSales from 'src/pages/report/Sales';
import BulkUpload from 'src/pages/BulkUpload';
import Counseling from 'src/pages/Counseling';
import InventoryList from 'src/pages/inventory/InventoryList';
import PatientEdit from 'src/pages/patients/PatientEdit';
import PatientAnswers from 'src/pages/patients/PatientAnswers';
import PatientQuestions from 'src/pages/patients/PatientQuestions';
import CalendarSchedule from 'src/pages/CalendarSchedule';

function App() {
  return (
    <Router>
      <StoreProvider>
        <NotifyProvider>
          <DataSmallProvider>
            <DefaultLayout>
              <Routes>
                <Route path='/login' element={<Login />} />
                <Route element={<ProtectedRoutes />}>
                  <Route
                    path='/'
                    element={<Navigate to='/reception' replace />}
                  />
                  <Route path='/reception' element={<Reception />} />
                  <Route path='/payments' element={<Payments />} />
                  <Route path='/calendar' element={<Navigate to="/calendar/index" replace />} />
                  <Route path='/calendar/index' element={<Calendar />} />
                  <Route path='/calendar/month' element={<CalendarSchedule />} />
                  <Route path='/reservations' element={<ReservationList />} />
                  <Route path='/quotations' element={<Quotations />} />
                  <Route
                    path='/quotation/detail'
                    element={<QuotationDetail />}
                  />
                  <Route path='/patients' element={<Patients />} />
                  <Route path='/patient/view' element={<PatientView />} />
                  <Route path='/patient/detail' element={<PatientDetail />} />
                  <Route path='/patient/schema' element={<MedicalSchema />} />
                  <Route path='/patient/task' element={<Tasks />} />
                  <Route path='/patient/task-edit' element={<TaskCreate />} />
                  <Route path='/patient/history' element={<PatientHistory />} />
                  <Route path='/patient/answers' element={<PatientAnswers />} />
                  <Route
                    path='/patient/questions'
                    element={<PatientQuestions />}
                  />
                  <Route
                    path='/master/patient-edit'
                    element={<PatientEdit />}
                  />
                  <Route
                    path='/patient/integration'
                    element={<PatientIntegration />}
                  />
                  <Route path='/report/download' element={<ReportDownload />} />
                  <Route path='/report/payment' element={<ReportPayment />} />
                  <Route path='/report/sales' element={<ReportSales />} />
                  {/* <Route path='/socket' element={<Socket />} /> */}
                  <Route path='/stocks' element={<InventoryManagement />} />
                  <Route
                    path='/stocks/surgical-material'
                    element={<SurgicalInventoryMangement />}
                  />
                  <Route path='/master/surgery' element={<MasterTreatment />} />
                  <Route
                    path='/master/product'
                    element={<MasterMerchandise />}
                  />
                  <Route
                    path='/master/product-op'
                    element={<MasterSurgicalMaterials />}
                  />
                  <Route
                    path='/master/part'
                    element={<MasterDesiredTreatment />}
                  />
                  <Route
                    path='/master/doctor-config'
                    element={<MasterDoctorFee />}
                  />
                  <Route path='/user/index' element={<SettingUsers />} />
                  <Route path='/user/view' element={<SettingUserView />} />
                  <Route path='/user/edit' element={<SettingUserEdit />} />
                  <Route
                    path='/user/change-password'
                    element={<SettingUserChangePassword />}
                  />
                  <Route
                    path='/master/patient-icon'
                    element={<SettingPatientIcon />}
                  />
                  <Route
                    path='/master/reserve-color'
                    element={<SettingCalendarColor />}
                  />
                  <Route path='/master/time' element={<SettingTime />} />
                  <Route
                    path='/master/time-edit'
                    element={<SettingTimeEdit />}
                  />
                  <Route path='/setting/site' element={<SettingSite />} />
                  <Route path='/master/email' element={<TemplateMail />} />
                  <Route
                    path='/master/email-log'
                    element={<TemplateMailLog />}
                  />
                  <Route
                    path='/template/quotation'
                    element={<TemplateQuotation />}
                  />
                  <Route
                    path='/master/email-view'
                    element={<TemplateMailView />}
                  />
                  <Route
                    path='/master/email-edit'
                    element={<TemplateMailEdit />}
                  />
                  <Route path='/bulkupload' element={<BulkUpload />} />
                  <Route path='/counseling' element={<Counseling />} />
                  <Route path='/inventory' element={<InventoryList />} />
                  <Route
                    path='/surgery-calendar'
                    element={<SurgeryCalendar />}
                  />
                  <Route
                    path='/surgery-schedule'
                    element={<SurgeryCalendar />}
                  />
                  <Route path='*' element={<NotFound />} />
                </Route>
              </Routes>
            </DefaultLayout>
          </DataSmallProvider>
        </NotifyProvider>
      </StoreProvider>
    </Router>
  );
}

export default App;
